import { createFileRoute, Link } from "@tanstack/react-router";

import { JsonLd } from "@/components/site/JsonLd";
import { CtaBand } from "@/components/site/Sections";
import { SiteLayout } from "@/components/site/SiteLayout";
import { listPublishedPosts } from "@/lib/blog.functions";
import { breadcrumbSchema, canonicalLink, metaFor } from "@/lib/seo";

const title = "Blog do Chaveiro em Betim | Dicas de Chaves e Fechaduras — Chavel";
const description =
  "Conteúdo semanal sobre segurança, chaves, fechaduras digitais, controles de portão e chaveiro 24 horas em Betim, escrito pela equipe da Chavel.";

export const Route = createFileRoute("/blog/")({
  loader: () => listPublishedPosts(),
  head: () => ({
    meta: metaFor({ title, description, path: "/blog" }),
    links: canonicalLink("/blog"),
  }),
  component: BlogIndex,
});

function BlogIndex() {
  const posts = Route.useLoaderData();

  return (
    <SiteLayout>
      <JsonLd
        data={breadcrumbSchema([
          { name: "Início", url: "/" },
          { name: "Blog", url: "/blog" },
        ])}
      />

      <section className="bg-surface text-surface-foreground">
        <div className="container-page py-14">
          <h1 className="font-display text-4xl">Blog da Chavel Chaveiro Betim</h1>
          <p className="mt-4 max-w-3xl opacity-90">
            Guias completos sobre chaves, fechaduras, automação de portões e segurança residencial em Betim. Novos
            conteúdos duas vezes por semana.
          </p>
        </div>
      </section>

      <section className="container-page py-12">
        {posts.length === 0 ? (
          <p className="text-muted-foreground">
            Ainda não há artigos publicados. Os conteúdos gerados automaticamente aparecem aqui assim que forem
            publicados no painel.
          </p>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {posts.map((post) => (
              <article key={post.slug} className="flex flex-col overflow-hidden rounded-xl border border-border bg-card">
                {post.image_url ? (
                  <img
                    src={post.image_url}
                    alt={post.image_alt ?? post.title}
                    loading="lazy"
                    className="h-44 w-full object-cover"
                  />
                ) : null}
                <div className="flex flex-1 flex-col p-5">
                  <h2 className="text-lg font-semibold leading-snug">
                    <Link to="/blog/$slug" params={{ slug: post.slug }} className="hover:text-primary">
                      {post.title}
                    </Link>
                  </h2>
                  <p className="mt-2 line-clamp-3 flex-1 text-sm text-muted-foreground">{post.excerpt}</p>
                  <p className="mt-4 text-xs text-muted-foreground">
                    {post.neighborhood ? `${post.neighborhood}, Betim • ` : "Betim • "}
                    {post.published_at ? new Date(post.published_at).toLocaleDateString("pt-BR") : ""}
                  </p>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>

      <CtaBand title="Precisa de um chaveiro agora em Betim?" text="Atendimento 24 horas por WhatsApp e telefone." />
    </SiteLayout>
  );
}
